<template>
  <div>

    <el-container class="SelectBlock">
	
	<el-page-header style="margin-left: 0.5%;" @back="Back()" title="返回"></el-page-header>
	 
      <el-col :sapn="3" >
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link" style="color: #B9B9B9;" >
            选择查询的需要<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">根据资产名称查询</el-dropdown-item>
            <el-dropdown-item command="b">根据使用人姓名查询</el-dropdown-item>
            <el-dropdown-item command="c">根据资产固定编码查询</el-dropdown-item>
			<el-dropdown-item command="d">根据子任务查询</el-dropdown-item>
            <el-dropdown-item command="e">根据存放的区域查询</el-dropdown-item>
            <el-dropdown-item command="f">根据上传人查询</el-dropdown-item>
            <el-dropdown-item command="g">根据资产状态查询</el-dropdown-item>
            <el-dropdown-item command="h">根据部门查询</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>


          <el-input v-if="selectCheck == 'a'" v-model.trim="SForm.SpropertyName" placeholder="根据资产名称查询"></el-input>

          <el-input v-if="selectCheck == 'b'" v-model.trim="SForm.SownerId" :value="ManagerUser"  placeholder="根据使用人姓名查询">
              <el-button
                size="mini"
                 style="padding-right:10px"
                 slot="suffix"
                 type="text"
                @click="dialogManager = true">选择</el-button> </el-input>
                <el-dialog title="选择查询人员" :visible.sync="dialogManager" width="35%">
                  <el-tree
                    class ="TreeBlock"
                    :data="MangerData"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreeMangerClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>
                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogManager = false">取 消</el-button>
                    <el-button type="primary" @click="dialogManager = false;">确 定</el-button>
                  </div>
                </el-dialog>


          <el-input v-if="selectCheck == 'c'" v-model.trim="SForm.SpropertyCode" placeholder="根据资产固定编码查询"></el-input>

          <el-input v-if="selectCheck == 'e'" v-model.trim="SForm.SplaceId" :value="SForm.SplaceRealId"
          append-to-body
          style="width: 250px;"
          placeholder="根据存放的区域查询">
              <el-button
                size="mini"
                 style="margin-top: 5px;"
                 slot="suffix"
                 type="text"
                @click="dialogPlace = true">选择</el-button></el-input>
                <el-dialog title="选择资产存放区域" :visible.sync="dialogPlace" width="35%">
                  <el-tree
                    class ="TreeBlock"
                    :data="PlaceData"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreePlaceClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>
                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogPlace = false">取 消</el-button>
                    <el-button type="primary" @click="dialogPlace = false;">确 定</el-button>
                  </div>
                </el-dialog>



          <el-input v-if="selectCheck == 'f'" v-model.trim="SForm.SupUserName" :value="SForm.SupUserId"
          append-to-body
          style="width: 250px;"
          placeholder="根据上传人信息查询">
              <el-button
                size="mini"
                 style="margin-top: 5px;"
                 slot="suffix"
                 type="text"
                @click="dialogUpUser= true">选择</el-button></el-input>
                <el-dialog title="选择上传人" :visible.sync="dialogUpUser" width="35%">
                  <el-tree
                    class ="TreeBlock"
                    :data="UpUserData"
                    :filter-node-method="filterNode"
                    node-key="id"
                    @node-click="TreeUpUserClick"
                    ref="tree"
                    :props="defaultProps"
                    default-expand-all:false
                    :expand-on-click-node="false">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span>{{ node.label }}</span>
                    </span>
                  </el-tree>
                  <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogUpUser = false">取 消</el-button>
                    <el-button type="primary" @click="dialogUpUser = false;">确 定</el-button>
                  </div>
                </el-dialog>







          <el-select v-if="selectCheck == 'd'" v-model.trim="SForm.SbelongTaskId" placeholder="根据子任务查询">
              <el-option
              v-for="i in Dtask"
              :key="i.taskId"
              :label="i.taskName"
              :value="i.taskId">
              </el-option>
          </el-select>






          <el-select v-if="selectCheck == 'g'" v-model.trim="SForm.SpropertyState" placeholder="是否为资产状态">
            <el-option label="正常" value='1'></el-option>
            <el-option label="盘亏" value='2'></el-option>
            <el-option label="盘盈" value='3'></el-option>
            <el-option label="异常" value='4'></el-option>
            <el-option label="待处理" value='5'></el-option>
          </el-select>

          <el-select v-if="selectCheck == 'h'" v-model="SForm.SdepartmentName"  placeholder="根据部门编号查询">
              <el-option
              v-for="i in DName"
              :key="i.departmentId"
              :label="i.departmentName"
              :value="i.departmentId">
              </el-option>
          </el-select>


		<el-button type="text"  @click="select(1)">查询</el-button>
		<el-button type="text" style="color: black;" @click="resetForm('SForm')">重置</el-button>
		
        <!-- <el-button type="primary" @click="select(1)">查询</el-button>
        <el-button type="primary" @click="resetForm('SForm')">重置</el-button> -->
      </el-col>
        <el-button type="primary" @click="Download()">导出异常信息</el-button>

    </el-container>




     <el-table
        :data="tableData"
        border
        style="width: 100%;margin-top: 2%;">
        <el-table-column
          prop="propertyCode"
          label="资产编码"
          width="180">
        </el-table-column>

        <el-table-column
          prop="propertyName"
          label="资产名称">
        </el-table-column>

        <el-table-column
          prop="propertyType"
          label="资产类别">
        </el-table-column>

        <el-table-column
          prop="upUser"
          label="上传人">
        </el-table-column>

        <el-table-column
          prop="upDate"
          label="上传时间">
        </el-table-column>


        <el-table-column
          label="资产状态"
          prop="state"
          >
          <template slot-scope="scope">
            <el-tag
            :type="scope.row.state == 1?''
            :(scope.row.state==2?'success'
            :(scope.row.state==3?''
            :(scope.row.state==4?''
            :(scope.row.state==5?'danger':'warning'))))"
            effect="dark">
              <div v-if="scope.row.state == 1">正常</div>
              <div v-if="scope.row.state == 2">盘亏</div>
              <div v-if="scope.row.state == 3">盘盈</div>
              <div v-if="scope.row.state == 4">异常</div>
              <div v-if="scope.row.state == 5">待处理</div>
            </el-tag>
          </template>
        </el-table-column>


        <el-table-column label="操作" key="slot">
            <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="dialogFormEdit = true;handleEdit(scope.row)">编辑</el-button>
                  <el-dialog title="修改资产" :visible.sync="dialogFormEdit" width="35%">
                    <DetectDataEdit ref="child"></DetectDataEdit>
                  </el-dialog>
                  <el-button type="text" @click="table = true;getImage(scope.row.photo);getRowData(scope.row)">详情</el-button>
				  
				
                  <el-drawer
                    title="资产详情!"
                    :visible.sync="table"
                    direction="rtl"
                    size="50%">
                    <el-descriptions border :column="2" style="width: 95%;margin-left: 2%;">
                        <el-descriptions-item label="上传时间">{{RowData.upDate}}</el-descriptions-item>
                        <el-descriptions-item label="使用部门">{{RowData.useDept}}</el-descriptions-item>
                        <el-descriptions-item label="使用人">{{RowData.user}}</el-descriptions-item>
						<el-descriptions-item label="上传人">{{RowData.upUser}}</el-descriptions-item>
						<el-descriptions-item label="公司">{{RowData.unit}}</el-descriptions-item>
						<el-descriptions-item label="购入时间">{{RowData.gainDate}}</el-descriptions-item>
                    </el-descriptions>
                    <h1>留证图片</h1>
                    <el-image
                           style="width: 500px; height: 500px"
                           :src="url"></el-image>
                  </el-drawer>
              </template>
            </el-table-column>
      </el-table>

      <div class="block">
               <el-pagination
                 @size-change="select"
                 @current-change="select"
                 :current-page.sync="currentPage"
                 :page-size="10"
                 layout="prev, pager, next, jumper"
                 :total="pageSize">
               </el-pagination>
             </div>


<!--
    <el-button
     style="margin-top: 2%;"
     type="primary" @click="Back()">返回上一页</el-button> -->
  </div>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  import DetectDataEdit from "./DetectDataEdit.vue"
  export default {
     name: 'DetectIndexDeatail',
     components:{
       DetectDataEdit
     },
     data () {
			 // 存入区域数据
       const PlaceData = [{
               id: 1,
               label: '一级 1',
               children: [{
                 id: 4,
                 label: '二级 1-1',
                 children: [{
                   id: 9,
                   label: '三级 1-1-1'
                 }, {
                   id: 10,
                   label: '三级 1-1-2'
                 }]
               }]
             }];
       return {
		   // dialogUpUser里面visible属性需要的变量，当它为false隐藏，为ture则显示弹框
         dialogUpUser:false,
		 // dialogManager里面visible属性需要的变量，当它为false隐藏，为ture则显示弹框
        dialogManager:false,
		// 存入管理员Id数据
        ManagerUser:'',
		// table里面visible属性需要的变量，当它为false隐藏，为ture则显示弹框
         table:false,
		 //  dialogFormEdit里面visible属性需要的变量，当它为false隐藏，为ture则显示弹框
         dialogFormEdit:false,
		 // 图片需要使用完整链接，使用url拼接
         url:'https://assert.hyhdit.com/api',
		 // 存入CheckBox的数据
         selectCheck:'',
		 // 分页的两个数据
        currentPage: 1,
        pageSize:1,
		
		// 存入管理人数据
        MangerData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],
		// 存入上传人数据
       UpUserData:[{
              id:'',
              label: '',
              realId:'',
              operator:'',
              children: [{
                id:'',
                label: '',
                realId:'',
                operator:'',
                children: [{
                  id:'',
                  label: '',
                  realId:'',
                  operator:'',
                }]
              }]
            }],

		// 存入条件搜索的条件
        SForm:{
          SpropertyName:'',
          SpropertyCode:'',
          SpropertyTypeId:'',
          SplaceId:'',
          SownerId:'',
          SunitId:'',
          SpropertyState:'',
          SupUserId:'',
          SbelongTaskId:'',
          SdepartmentName:'',
          SupUserName:'',

        },
		// 将PlaceData的树Json化
        PlaceData: JSON.parse(JSON.stringify(PlaceData)),
		//  dialogPlace里面visible属性需要的变量，当它为false隐藏，为ture则显示弹框
        dialogPlace:false,
		// 存入部门数据
        DName:[{
          departmentId:'',
          departmentName:'',
        }],
        defaultProps: {
                 children: 'children',
                 label: 'label'
               },
		// 存入子任务数据
        Dtask:[{
          taskId:'',
          taskName:'',
        }],
		// 存入清查资产数据
        tableData:[{
          propertyCode:'',
          propertyName:'',
          propertyTypeId:'',
          useDeptId:'',
          userId:'',
          placeId:'',
          upUserId:'',
          belongTaskId:'',
          belongDetectId:'',
          state:'',
          pageSize:'',
          currentPage:'',
        }],
		RowData:'',
        detectId: '',
        };
     },
     watch: {
           filterText(val) {
             this.$refs.tree.filter(val);
           }
         },
    created() {
      // console.log(this.$parent.detectId)
      this.detectId = this.$parent.detectId
    },
     mounted:function() {
		// 首先是当页面加载的时候自动渲染这些数据		
			 
		// 加载同时加载子页面
       this.$refs.child
	   
	   // 表格里面的数据
       this.showData();
      // this.select()
	   // 查询条件里面的数据预加载    部门信息
       this.showDepartmentData();
	   // 查询条件里面的数据预加载    人员信息
       this.showMData();
	   // 查询条件里面的数据预加载    区域信息
       this.showPlaceData();
	   // 查询条件里面的数据预加载    清查单信息
       this.showDetectData();
     },
     methods: {
	  getRowData(data){
		  this.RowData = data
	  }, 
	  // 返回页面的功能
      Back(){
        this.$parent.page=1
      },
	  // 显示图片添加路径
      getImage(row){
        this.url = "https://assert.hyhdit.com"+row
      },
	  // 调用子组件将需要修改某一行的值传给DetectDataEdit
      handleEdit(rows) {
        this.$nextTick(()=>{
          this.$refs.child.showIndexData(rows)
        })
           },
	  // 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
      TreePlaceClick(data){
          this.SForm.SplaceRealId = data.id
          this.SForm.SplaceId = data.label

      },
	  // 获取上传人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是上传人ID
      TreeUpUserClick(data){
        this.SForm.SupUserName = data.label
        this.SForm.SupUserId = data.id
      },
	  // 获取管理人信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是管理人ID
      TreeMangerClick(data){

          this.ManagerUser = data.realId
          this.SForm.SownerId = data.label
      },
	  // 获取区域信息之后将树状信息进行更改，使得显示的是文字信息但是传输的是区域ID
      TreeOutPlaceClick(data){
          this.OutPlaceId = data.label
      },

      filterNode(value, data) {

              if (!value) return true;
              return data.label.indexOf(value) !== -1;
            },

	  // 下拉菜单存放点击时选中的数据
      handleCommand(command) {
             this.selectCheck = command
            },
	  // 重置数据
      resetForm(formName) {
        Object.assign(this.$data.SForm, this.$options.data().SForm)
        this.ManagerUser = 0;
        this.select()
          },



	  // 获取人员数据
      showMData(){
       var authorization = Cookies.get("Authorization");
        this.axios({
            method: 'GET',
            url: '/public/getUnitTree',
            header:{
             'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{
           // var arr = new Array(resp.data.data) ;
           this.MangerData=resp.data.data;
           this.UserData = resp.data.data;
           this.UpUserData =resp.data.data;
          })
      },
	  // 获取区域数据
      showPlaceData(){
       var authorization = Cookies.get("Authorization");
        this.axios({
            method: 'GET',
            url: '/public/getTree',
            header:{
             'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{

           this.PlaceData=resp.data.data;
          })
      },



	  // 获取清查单数据
      showDetectData(){
       var authorization = Cookies.get("Authorization");
       var params = {
         currentPage: 1,
         pageSize: 5,
       }
        this.axios({
            method: 'GET',
            url: '/detect/taskSearch',
            params:params,
            header:{
             'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{
          this.Dtask = resp.data.data
          })
      },







	  // 通过条件查询，SForm里面村的是所有条件查询的数据
      select(val){
        var authorization = Cookies.get("Authorization");
        var num = this.$parent.detectId
        var params = {
          propertyCode:this.SForm.SpropertyCode|| undefined,
          propertyName:this.SForm.SpropertyName|| undefined,
          propertyTypeId:this.SForm.SpropertyTypeId|| undefined,
          userId:this.ManagerUser || undefined,
          useDeptId:this.SForm.SdepartmentName || undefined,
          placeId:this.SForm.SplaceId || undefined,
          upUserId:this.SForm.SupUserId || undefined,
          state:parseInt(this.SForm.SpropertyState)  || undefined,
          belongTaskId:this.SForm.SbelongTaskId || undefined,
          belongDetectId:num,
          currentPage: val || 1,
          pageSize: 10,
        }
         this.axios({
             method: 'GET',
             url: '/detect/detailSearch',
             params:params,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
              this.tableData = resp.data.data
              this.pageSize = resp.data.count;
           })
      },
	  
	  // 获取部门数据
      showDepartmentData(){
       var authorization = Cookies.get("Authorization");
       var params = {
         currentPage: 1,
         pageSize: 5,
       }
        this.axios({
            method: 'GET',
            url: '/public/getCanHandleDepartmentList',
            params:params,
            header:{
             'Authorization':authorization,
            	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
            	}
          }).then((resp)=>{
           this.DName = resp.data.data;
          })
      },






	  // 导出当前清查数据
      Download() {
        // console.log(this.detectId)
          var authorization = Cookies.get("Authorization");
					this.axios({
					    method: 'POST',
					    url: '/detect/export',
					    // params:params,
              // data: {
              //   detectId: this.detectId
              // },
              params: {
                detectId: this.detectId
              },
					    header:{
					     // 'Authorization':authorization,
					    	// 'Content-Type':'application/json'  //如果写成contentType会报错,如果不写这条也报错
					    	}
					  }).then((res)=>{
					   console.log(res)
					   if(res.data.code == 200) {
						   window.open(res.data.data)
					   }
					  })
        //   fetch('https://assert.hyhdit.com/apiYang/detect/export', {
        //       method: 'POST',
        //       headers:{
        //         'Content-Type': 'application/json',
        //         'Authorization': authorization
        //       },
        //   })
        //  .then(res => res.blob())
        //  .then(data => {
        //       const blobUrl = window.URL.createObjectURL(data);
        //       const a = document.createElement('a');
        //       a.download = this.fileName+'.xlsx';
        //       a.href = blobUrl;
        //       a.click();
        // });
        
        // this.axios({
        //     method: 'POST',
        //     url: '/detect/export',
        //     // params:params,
        //     header:{
        //      'Authorization':authorization,
        //     	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
        //     	}
        //   }).then((res)=>{
        //     console.log(res)
        //   })
      },







	  // 获取所有清查数据，不做任何分类处理
      showData(){
        var authorization = Cookies.get("Authorization");
        var num = this.$parent.detectId
        var params = {
          belongDetectId:num,
          currentPage: 1,
          pageSize: 10,
        }
         this.axios({
             method: 'GET',
             url: '/detect/detailSearch',
             params:params,
             header:{
              'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
              this.tableData = resp.data.data
              this.pageSize = resp.data.count;
           })
      }
     }
   }
</script>
<style>
 .SelectBlock .el-input{
      width: 400px;
    }
 .el-page-header__title{
	 margin-top: 13%;
	 width: 30px;
 }
</style>



// WEBPACK FOOTER //
// src/components/Detect/DetectIndexDetail.vue